<template>
  <div class="home-wrap">
    <div class="banner">
      <img :src="require('../assets/images/banner.png').default" alt="">
    </div>
    <aboutUs />
    <management />
    <atlas />
    <industry />
  </div>
</template>

<script>
import management from '@/components/home/ManagementInfo'
import atlas from '@/components/home/AtlasMap'
import industry from '@/components/home/IndustryInfo'
import AboutUs from '@/components/home/AboutUs.vue'
export default {
  components: {
    AboutUs,
    atlas,
    industry,
    management
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/sass/variable.scss';
.home-wrap {
  width: 100%;
  overflow: hidden;
  .banner{
    img {
      width: 100%;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>
